import dayjs from "dayjs";
import { HandlebarsRender } from "./handlebars";
import { setCookie, getCookie, GetLang, GetWar, SetUser, SetWar, fetchError, TIMEOUT, clkecFetch } from "./utils";
import SweetAlert from "sweetalert2";
import { openLoading, closeLoading } from "./swal";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';
import { GetCurrentCurrency } from "../../src/ts/main";
const Toast = SweetAlert.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', SweetAlert.stopTimer);
        toast.addEventListener('mouseleave', SweetAlert.resumeTimer);
    }
});
export function fbqSearch(searchTerm, data) {
    try {
        if (window.fbq) {
            var searchData = {
                search_string: searchTerm,
                content_category: 'Product Search',
                content_ids: data.items.map((el) => { return el['code']; }),
                content_type: 'product'
            };
            window.fbq('track', 'Search', searchData);
            console.log('CLKEC_EVENTS_EVENT', `window.fbq("track", "Search", ${JSON.stringify(searchData)});`);
        }
    }
    catch (e) {
        console.error(e);
    }
}
export function gtagSearch(searchTerm, data) {
    try {
        if (window.gtag) {
            var searchData = { search_term: searchTerm };
            window.gtag('event', 'search', searchData);
            console.log('CLKEC_EVENTS_EVENT', `window.gtag('event', 'search', ${JSON.stringify(searchData)});`);
        }
    }
    catch (e) {
        console.error(e);
    }
}
export class LoginError extends Error {
}
export class User {
    constructor(templateSelector, containerSelector, dataResolver, callback) {
        this.data = {};
        this.dataResolver = dataResolver;
        this.templateSelector = templateSelector;
        this.containerSelector = containerSelector;
        this.callback = callback;
        this.getSessionId();
    }
    async set_extra(key, value) {
        this.data['extras'] = this.data['extras'] || {};
        this.data['extras'][key] = value;
        let response = await this.dataResolver.updateUserProfile(this.token.access_token, this.data);
        this.data = response;
        this.save();
        return this;
    }
    static createUser(templateSelector, containerSelector, dataResolver, callback) {
        if (User.instance) {
            return User.instance.loadFromStorage();
        }
        console.debug("creating an User instance");
        let instance = new User(templateSelector, containerSelector, dataResolver, callback);
        instance.loadFromStorage();
        instance.save();
        User.instance = instance;
        console.debug('user', "token", User.instance.token);
        console.debug('user', "needsToBeReload", User.instance.needsToBeReload());
        if (!User.instance.token || User.instance.needsToBeReload()) {
            console.debug('user', "User.instance.clear");
            User.instance.clear();
        }
        else {
            console.debug('user', "renewTokenPeriodicaly");
            User.instance.renewTokenPeriodicaly();
        }
        try {
            var user_id = Object(instance.data)['hash_id'];
            window.gtag('config', window.GOOGLE_ANALYTICS_ID, { 'user_id': user_id });
            console.debug('SET USER', user_id);
        }
        catch (ex) { }
        return User.instance;
    }
    getSessionId() {
        let sesId = getCookie('sessionId');
        if (!sesId) {
            sesId = uuidv4();
            //console.debug('SESSION', 'Create new session', sesId);
            setCookie('sessionId', sesId, 0);
        }
        else {
            //console.debug('SESSION', 'Curren session', sesId);
        }
        return sesId;
    }
    async registerUser(username, password) {
        console.debug('user', "token", User.instance.token);
        let response = await this.dataResolver.registerUser(username, password);
        return response;
    }
    async registerUserWithInfo(user_info) {
        console.debug('user', "token", User.instance.token);
        let response = await this.dataResolver.registerUserWithInfo(user_info);
        return response;
    }
    async sendActivation(username) {
        let response = await this.dataResolver.sendActivation(username);
        return response;
    }
    async recoverPassword(username) {
        let response = await this.dataResolver.recoverPassword(username);
        return response;
    }
    async changePassword(hash, password1, password2) {
        let response = await this.dataResolver.changePassword(hash, password1, password2);
        return response;
    }
    stringify() {
        return JSON.stringify({
            token: this.token,
            data: this.data
        });
    }
    loadFromStorage() {
        let user = JSON.parse(localStorage.getItem(User.identifier));
        if (!user) {
            return this;
        }
        this.token = user.token;
        this.data = user.data;
        return this;
    }
    getToken() {
        this.loadFromStorage();
        return this.token;
    }
    save() {
        localStorage.setItem(User.identifier, this.stringify());
        if (this.token) {
            SetUser(this.token.access_token);
        }
        else {
            SetUser('');
        }
    }
    needsToBeReload(show = false) {
        if (!this.token) {
            return true;
        }
        let margin = User.MINUTES_OFFSET * 60;
        let now = dayjs().unix();
        console.debug('user', 'needsToBeReload', 'now', now);
        console.debug('user', 'needsToBeReload', 'expiration', this.token.expiration);
        console.debug('user', 'needsToBeReload', 'margin', margin);
        let diference = this.token.expiration - now;
        if (show) {
            console.log('token expiration', this.token.expiration);
            console.log('now', now);
            console.log('Diferencia', diference);
            console.log('margin', margin);
        }
        return diference <= margin;
    }
    render() {
        let render = new HandlebarsRender(this.templateSelector, this.containerSelector);
        const payload = {
            isLoggedIn: this.isLoggedIn(),
            data: this.data,
        };
        render.render(payload, true, this.callback);
    }
    isLoggedIn() {
        return !!this.token && !this.needsToBeReload();
    }
    clear() {
        this.data = null;
        this.token = null;
        this.save();
    }
    logOut() {
        this.clear();
        this.render();
        SetUser('');
        try {
            window.localStorage.removeItem(User.identifier);
        }
        catch (e) { }
        window.location.pathname = "/";
    }
    async logIn(user, password, successUrl = "/") {
        try {
            let token = await this.dataResolver.loginUser(user, password);
            this.token = token;
            this.data = await this.dataResolver.fetchUserData(this.token.access_token);
            // @ts-ignore
            let warehouse = this.data["warehouse"];
            SetWar(warehouse);
            this.save();
            window.location.pathname = successUrl;
            return true;
        }
        catch (LoginError) {
            return false;
        }
    }
    async renewToken() {
        try {
            if (this.token) {
                console.debug("renewing login token");
                let token = await this.dataResolver.renewLoginToken(Object(this.data)['email'], this.token.access_token);
                this.token = token;
                this.save();
                this.render();
            }
        }
        catch (e) {
            this.logOut();
        }
    }
    renewTokenPeriodicaly() {
        setInterval(() => {
            console.debug("setting interval");
            if (!this.needsToBeReload()) {
                console.debug("renewing login token");
                this.renewToken();
            }
        }, 1000 * 60 * User.MINUTES_OFFSET / 2 // 2.5 minutes in milliseconds
        );
    }
    async getOrders(containerSelector, templateSelector, callback) {
        var _a;
        const render = new HandlebarsRender(templateSelector, containerSelector);
        const orders = await this.dataResolver.getUserOrders(this.token.access_token);
        if (!((_a = orders === null || orders === void 0 ? void 0 : orders.orders) === null || _a === void 0 ? void 0 : _a.length)) {
            console.warn("No hay órdenes o la estructura no es válida");
            return;
        }
        const final_orders = orders.orders.map((order) => {
            var _a;
            const lines = (_a = order.meta_data.final_lines) !== null && _a !== void 0 ? _a : [];
            order.meta_data.final_lines = lines.map((item) => {
                if (item.line) {
                    return Object.assign(Object.assign({}, item.line), { type: item.type });
                }
                return item;
            });
            if (!order.meta_data.final_lines || order.meta_data.final_lines.length == 0) {
                order.meta_data.final_lines = order.meta_data.repo.map((item) => {
                    return Object.assign(Object.assign({}, item), { type: 'product' });
                });
                console.log('EMPTY', order);
            }
            return order;
        });
        console.log(final_orders);
        render.render(final_orders);
        callback === null || callback === void 0 ? void 0 : callback.call(this);
    }
    async getUpdateProfileForm(containerSelector, templateSelector, callback, successCallback) {
        let render = new HandlebarsRender(templateSelector, containerSelector);
        try {
            let formTemplateData = await this.dataResolver.getUpdateProfileForm(this.token.access_token);
            this.data = formTemplateData;
            this.save();
            console.log('formTemplateData', formTemplateData);
            render.render(formTemplateData, false, callback);
            console.log('UpdateUserProfile');
            document.dispatchEvent(new CustomEvent('UpdateUserProfile', {
                'detail': {
                    'user': this
                }
            }));
        }
        catch (LoginError) {
            this.logOut();
            return;
        }
        const form = document.querySelector(`${containerSelector} form`);
        form.addEventListener("submit", event => {
            event.preventDefault();
            const formData = new FormData(form);
            this.updateUserProfile(formData, successCallback);
        });
    }
    async updateUserProfile(payload, successCallback) {
        let data = Object.fromEntries(payload.entries());
        if (data.hasOwnProperty('birth_date')) {
            let birth_date = data['birth_date'];
            if (birth_date.indexOf('/') > 0) {
                let sdate = birth_date.split('/');
                data['birth_date'] = sdate[2] + '-' + sdate[1] + '-' + sdate[0];
            }
        }
        if (data['birth_date'] == "") {
            data['birth_date'] = null;
        }
        data['warehouse'] = GetWar();
        let response = await this
            .dataResolver
            .updateUserProfile(this.token.access_token, data);
        this.data = response;
        this.save();
        this.render();
        successCallback === null || successCallback === void 0 ? void 0 : successCallback.call(this);
    }
    async listShipping() {
        return this.dataResolver.listShippingAddress();
    }
    async createShipping(data) {
        return this.dataResolver.createShippingAddress(data);
    }
    async detailShipping(id) {
        return this.dataResolver.detailShippingAddress(id);
    }
    async updateShipping(data) {
        return this.dataResolver.updateShippingAddress(data);
    }
    async deleteShipping(id) {
        return this.dataResolver.deleteShippingAddress(id);
    }
    async listShippingTownships() {
        let headers = Object({});
        let user = null;
        let session_id = '';
        let clkuser = '';
        if (window.Clkec) {
            user = window.Clkec.user;
            if (user) {
                let token = user.getToken();
                if (token) {
                    clkuser = `${token.access_token}`;
                }
                session_id = window.Clkec.user.getSessionId();
            }
        }
        var url = new URL(`${window.API_URL}/api/shipping/townships/?pc=${GetCurrentCurrency()}`);
        let response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'X-CLKECSESSIONID': session_id,
                'X-CLKECUSER': clkuser
            }
        });
        let result = await response.json();
        return result;
    }
    async ShippingModal(input) {
        let data = Object({});
        if (input.value) {
            data = JSON.parse(input.value);
        }
        let townships = await this.listShippingTownships();
        let html_template = await this.dataResolver.templateShippingAddress(data);
        if (!html_template) {
            return;
        }
        let formContainer = document.createElement('div');
        formContainer.innerHTML = html_template;
        var emptyOption1 = document.createElement('option');
        emptyOption1.value = '';
        emptyOption1.text = '---';
        let township_selector = formContainer.querySelector('#id_township');
        township_selector.innerHTML = '';
        township_selector.appendChild(emptyOption1);
        let selectedTownship = null;
        townships.values.forEach((el) => {
            var option = document.createElement('option');
            option.value = el.id;
            option.text = el.name;
            if (data['township'] == el.id) {
                option.selected = true;
                option.setAttribute('selected', 'selected');
                selectedTownship = el;
            }
            township_selector.appendChild(option);
        });
        var emptyOption2 = document.createElement('option');
        emptyOption2.value = '';
        emptyOption2.text = '---';
        let zone_selector = formContainer.querySelector('#id_zone');
        zone_selector.innerHTML = '';
        zone_selector.appendChild(emptyOption2);
        if (selectedTownship) {
            selectedTownship.zones.forEach((elZone) => {
                var optionZone = document.createElement('option');
                optionZone.value = elZone.id;
                optionZone.text = elZone.name;
                if (data['zone'] == elZone.id) {
                    optionZone.selected = true;
                    optionZone.setAttribute('selected', 'selected');
                    console.log(optionZone);
                }
                zone_selector.appendChild(optionZone);
            });
        }
        return Swal.fire({
            title: '<strong>Dirección de entrega</strong>',
            // icon: 'info',
            html: `${formContainer.innerHTML}`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: true,
            confirmButtonText: 'Guardar',
            cancelButtonText: 'Cancelar',
            didOpen: (popup) => {
                var township = popup.querySelector('#id_township');
                var zone = popup.querySelector('#id_zone');
                if (!selectedTownship) {
                    zone.innerHTML = '';
                    zone.appendChild(emptyOption2);
                }
                township.addEventListener('change', (event) => {
                    var zone = popup.querySelector('#id_zone');
                    zone.innerHTML = '';
                    zone.appendChild(emptyOption2);
                    townships.values.forEach((el) => {
                        if (el.id == township.value) {
                            el.zones.forEach((elZone) => {
                                var option = document.createElement('option');
                                option.value = elZone.id;
                                option.text = elZone.name;
                                zone.appendChild(option);
                            });
                        }
                    });
                });
            },
            preConfirm: () => {
                const form = Swal.getPopup().querySelector('form');
                if (!form.checkValidity()) {
                    const inputs = form.querySelectorAll('input, select');
                    let showValid = false;
                    inputs.forEach((el) => {
                        if (!el.validity.valid && !showValid) {
                            el.reportValidity();
                            showValid = true;
                        }
                    });
                    //Swal.showValidationMessage('First input missing')   
                    return false;
                }
                const formEntries = new FormData(form).entries();
                const entries = Object.fromEntries(formEntries);
                console.log('entries', entries);
                return entries;
            }
        }).then((result) => {
            let data = Object(result.value);
            try {
                data['township'] = parseInt(data['township']);
            }
            catch (e) {
                data['township'] = null;
            }
            if (data['township'] == null || isNaN(data['township'])) {
                data['township'] = '';
            }
            try {
                data['zone'] = parseInt(data['zone']);
            }
            catch (e) {
                data['zone'] = null;
            }
            if (data['zone'] == null || isNaN(data['zone'])) {
                data['zone'] = '';
            }
            return {
                'result': result,
                'json': JSON.stringify(data)
            };
        });
    }
}
User.identifier = "__USER_DATA";
User.MINUTES_OFFSET = 5;
export class Menu {
    // private static identifier = "__MENU_DATA";
    constructor(templateSelector, containerSelector, templateMobileSelector, containerMobileSelector, templateSubmenuSelector, containerSubmenuSelector, expirationMinutes, dataResolver, callback) {
        this.expirationMinutes = expirationMinutes;
        this.dataResolver = dataResolver;
        this.templateSelector = templateSelector;
        this.containerSelector = containerSelector;
        this.templateMobileSelector = templateMobileSelector;
        this.containerMobileSelector = containerMobileSelector;
        this.templateSubmenuSelector = templateSubmenuSelector;
        this.containerSubmenuSelector = containerSubmenuSelector;
        this.callback = callback;
        this.menuEl = document.querySelector(this.containerMobileSelector + ' .menu');
        this.navEl = document.querySelector(this.containerMobileSelector + ' .navMenu');
    }
    static getIdentifier() {
        return window.key_ec_menu;
    }
    stringify() {
        return JSON.stringify({
            expirationMinutes: this.expirationMinutes,
            expirationToken: this.expirationToken,
            nextExpirationToken: this.nextExpirationToken,
            data: this.data
        });
    }
    loadFromStorage() {
        let menu = JSON.parse(localStorage.getItem(Menu.getIdentifier()));
        try {
            this.expirationMinutes = menu.expirationMinutes;
            this.expirationToken = menu.expirationToken;
            this.nextExpirationToken = menu.nextExpirationToken;
        }
        catch (e) {
            return null;
        }
        this.data = menu.data;
        if (!this.data) {
            return null;
        }
        if (this.data.menus && !this.data.menus.main) {
            return null;
        }
        this.render();
        return this;
    }
    save() {
        localStorage.setItem(Menu.getIdentifier(), this.stringify());
    }
    needsToBeReload(show = false) {
        let now = dayjs().unix();
        if (show) {
            console.log('nextExpirationToken', this.nextExpirationToken);
            console.log('now', now);
            console.log('Diferencia', this.nextExpirationToken - now);
        }
        return this.nextExpirationToken <= now;
    }
    delta() {
        return 60 * 1000 * this.expirationMinutes;
    }
    render() {
        if (document.querySelector(this.templateMobileSelector)) {
            this.renderMobile();
        }
        else {
            this.renderDesktop();
        }
    }
    renderDesktop() {
        let renderMain = new HandlebarsRender(this.templateSelector, this.containerSelector);
        if (renderMain) {
            renderMain.render(this.data['menus'], true, this.callback);
        }
        let renderSubmenu = new HandlebarsRender(this.templateSubmenuSelector, this.containerSubmenuSelector);
        if (renderMain) {
            renderSubmenu.render(this.data['menus'], true, this.callback);
        }
    }
    renderMobile() {
        let render = new HandlebarsRender(this.templateMobileSelector, this.containerMobileSelector + ' .menu-categories');
        if (render) {
            render.render(this.data, true, this.callback);
        }
        var modalSlider = document.getElementById('modalSlider');
        var shortcut_tpl = modalSlider.querySelector('.shortcut-tpl');
        if (shortcut_tpl && this.data && this.data.menus && this.data.menus.menu_shortcuts) {
            shortcut_tpl.classList.remove('shortcut_tpl');
            var lastEle = shortcut_tpl;
            for (var i = 0; i < this.data.menus.menu_shortcuts.length; i++) {
                var mnu = this.data.menus.menu_shortcuts[i];
                var short = shortcut_tpl.cloneNode(true);
                short.classList.remove('shortcut_tpl');
                short.querySelector('a').href = mnu['url'];
                short.querySelector('span').innerHTML = mnu['text'];
                lastEle.insertAdjacentElement('afterend', short);
                lastEle = short;
            }
            if (this.data.menus.globals) {
                Object.keys(this.data.menus.globals).forEach((key) => {
                    var cssname = key.split(',')[0];
                    var mnu_shortcut_tpl = modalSlider.querySelector(cssname + ' .' + 'inner-tpl');
                    if (mnu_shortcut_tpl) {
                        mnu_shortcut_tpl.classList.remove('inner-tpl');
                        lastEle = mnu_shortcut_tpl;
                        for (var i = 0; i < this.data.menus.globals[key].menus.length; i++) {
                            mnu = this.data.menus.globals[key].menus[i];
                            var mnu_short = mnu_shortcut_tpl.cloneNode(true);
                            mnu_short.querySelector('a').href = mnu['url'];
                            mnu_short.querySelector('span').innerHTML = mnu['text'];
                            lastEle.insertAdjacentElement('afterend', mnu_short);
                            lastEle = mnu_short;
                        }
                    }
                });
            }
            shortcut_tpl.remove();
        }
        this.mainMenu1 = new MultiLevelMenu(this.navEl, this.menuEl, "mainMenu1", "/static/mobile/assets/images/icon-arrow-left.svg");
        this.menuEl ? this.mainMenu1.drawMenu() : null;
        // var mobile_data = this.data;
        // mobile_data['for_shortcuts'] = true;
        // let render2 = new HandlebarsRender(this.templateMobileSelector + '_shortcuts', this.containerMobileSelector + ' .menu-shortcuts');
        // render2.render(mobile_data, true, this.callback);
    }
    reload() {
        this.expirationToken = this.nextExpirationToken;
        this.nextExpirationToken += (this.delta() / 1000);
        this.fetchData();
    }
    async checkStatusPeriodicaly() {
        //   setInterval(() => {
        //     if (this.needsToBeReload()){
        //       console.debug("re-fetching data");
        //       this.reload();
        //     }
        //   },
        //   10 * 1000
        //  )
    }
    async fetchData() {
        let data = await this.dataResolver.loadMenu();
        if (!data) {
            return;
        }
        this.data = data;
        this.save();
        if (document.querySelector(this.templateMobileSelector)) {
            this.renderMobile();
        }
        else {
            this.render();
        }
    }
    static createEmptyMenu(templateSelector, containerSelector, templateMobileSelector, containerMobileSelector, templateSubmenuSelector, containerSubmenuSelector, expirationMinutes, dataResolver, callback) {
        if (Menu.instance) {
            console.debug('MENU', 'loadFromStorage');
            let mnu = Menu.instance.loadFromStorage();
            if (mnu.expirationMinutes == expirationMinutes) {
                return mnu;
            }
        }
        console.debug('MENU', 'create new instance');
        let instance = new Menu(templateSelector, containerSelector, templateMobileSelector, containerMobileSelector, templateSubmenuSelector, containerSubmenuSelector, expirationMinutes, dataResolver, callback);
        if (!instance.needsToBeReload()) {
            let mnu2 = instance.loadFromStorage();
            if (mnu2) {
                if (mnu2.expirationMinutes == expirationMinutes) {
                    if (!instance.needsToBeReload()) {
                        mnu2.checkStatusPeriodicaly();
                        Menu.instance = mnu2;
                        return Menu.instance;
                    }
                }
            }
        }
        Menu.instance = instance;
        Menu.instance.expirationMinutes = expirationMinutes;
        Menu.instance.expirationToken = dayjs().unix();
        Menu.instance.nextExpirationToken = instance.expirationToken + (instance.delta() / 1000);
        Menu.instance.save();
        Menu.instance.fetchData();
        Menu.instance.checkStatusPeriodicaly();
        return Menu.instance;
    }
}
export class Api {
    constructor(apiUrl, menuEndpoint) {
        this.lastEvent = null;
        this.lastEventResult = null;
        this.is_valid = false;
        this.API_URL = apiUrl;
        if (this.API_URL.endsWith('/')) {
            this.API_URL = this.API_URL.substring(0, this.API_URL.length - 1);
        }
        this.MENU_ENDPOINT = menuEndpoint;
        if (this.API_URL && this.MENU_ENDPOINT) {
            this.is_valid = true;
        }
    }
    async loadMenu() {
        if (!this.is_valid) {
            return;
        }
        let params = Object({});
        params['w'] = GetWar();
        params['l'] = GetLang();
        var url = new URL(`${this.API_URL}${this.MENU_ENDPOINT}`);
        for (let k in params) {
            url.searchParams.append(k, params[k]);
        }
        let json = {};
        try {
            // @ts-ignore
            let signal = AbortSignal.timeout(TIMEOUT);
            let response = await fetch(url.toString(), { method: 'GET', credentials: "include", signal: signal });
            json = await response.json();
        }
        catch (err) {
            fetchError(err);
        }
        return { menus: json };
    }
    async loadBanners() {
        if (!this.is_valid) {
            return;
        }
        let path = window.location.pathname + window.location.search.replace(/&/g, '~');
        let url = new URL(window.location.toString());
        let urlpath = url.href.replace(url.origin, '');
        console.log('loadBanners', path);
        console.log('loadBanners', urlpath);
        let response = await fetch(`${this.API_URL}/api/banners/json/?&path=${path}`, { method: 'GET', credentials: "include" });
        let json = await response.json();
        let data = json.banners;
        return data;
    }
    async loadBannersHTML() {
        if (!this.is_valid) {
            return;
        }
        let path = window.location.pathname + window.location.search.replace(/&/g, '~');
        let url = new URL(window.location.toString());
        let urlpath = url.href.replace(url.origin, '');
        console.log('loadBanners', path);
        console.log('loadBanners', urlpath);
        const response = await fetch(`${this.API_URL}/api/banners/render/?&path=${path}`, { method: 'GET', credentials: "include" });
        let html = await response.text();
        return html;
    }
    async bannerRender(container) {
        if (!this.is_valid) {
            return;
        }
        this.loadBannersHTML().then((html) => {
            let el = document.querySelector(container);
            if (!el) {
                return;
            }
            el.innerHTML = html;
        });
    }
    async loadSection(slug) {
        if (!this.is_valid) {
            return;
        }
        let response = await fetch(`${this.API_URL}/api/section/block/${slug}/`, { method: 'GET', credentials: "include" });
        let json = await response.json();
        let data = json.sections[0];
        if (data) {
            data = data.template;
        }
        else {
            data = '';
        }
        return data;
    }
    async fetchVariantBase(variant_id) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        const payload = {
            method: "GET",
        };
        let user = null;
        let headers = {};
        if (window.Clkec) {
            user = window.Clkec.user;
            if (user) {
                let token = user.getToken();
                if (token) {
                    headers = { "X-CLKECUSER": `${token.access_token}` };
                }
            }
        }
        let params = Object({});
        params['w'] = GetWar();
        params['l'] = GetLang();
        var url = new URL(`${this.API_URL}/api/products/${variant_id}/detail/?nofollow=1`);
        for (let k in params) {
            url.searchParams.append(k, params[k]);
        }
        let response = await fetch(url.toString(), {
            method: 'GET',
            headers: headers,
            credentials: "include"
        });
        let json = await response.json();
        closeLoading();
        return json;
    }
    async fetchVariant(variant_id) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        const payload = {
            method: "GET",
        };
        let user = null;
        let headers = {};
        if (window.Clkec) {
            user = window.Clkec.user;
            if (user) {
                let token = user.getToken();
                if (token) {
                    headers = { "X-CLKECUSER": `${token.access_token}` };
                }
            }
        }
        let params = Object({});
        params['w'] = GetWar();
        params['l'] = GetLang();
        var url = new URL(`${this.API_URL}/api/products/${variant_id}/detail/`);
        for (let k in params) {
            url.searchParams.append(k, params[k]);
        }
        let response = await fetch(url.toString(), {
            method: 'GET',
            headers: headers,
            credentials: "include"
        });
        let json = await response.json();
        closeLoading();
        return json;
    }
    async loginUser(user, password) {
        if (!this.is_valid) {
            return;
        }
        let payload = new FormData();
        payload.append("username", user);
        payload.append("password", password);
        openLoading();
        let response = await fetch(`${this.API_URL}/api/token/`, {
            method: 'POST',
            body: payload,
            credentials: "include"
        });
        if (response.status !== 200) {
            closeLoading();
            throw new LoginError("Something bad happened");
        }
        let json = await response.json();
        // closeLoading();
        return json;
    }
    async registerUser(user, password) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let payload = new FormData();
        payload.append("username", user);
        payload.append("password", password);
        let response = fetch(`${this.API_URL}/api/register/`, {
            method: 'POST',
            body: payload,
            credentials: "include"
        });
        closeLoading();
        return response;
    }
    async registerUserWithInfo(user_info) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let response = fetch(`${this.API_URL}/api/register-with-info/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json' // Indica el tipo de contenido
            },
            body: JSON.stringify(user_info),
            credentials: "include"
        });
        closeLoading();
        return response;
    }
    async sendActivation(user) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let payload = new FormData();
        payload.append("username", user);
        let response = fetch(`${this.API_URL}/api/activate/`, {
            method: 'POST',
            body: payload,
            credentials: "include"
        });
        closeLoading();
        return response;
    }
    async recoverPassword(user) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let payload = new FormData();
        payload.append("username", user);
        let response = fetch(`${this.API_URL}/api/recover-password/`, {
            method: 'POST',
            body: payload,
            credentials: "include"
        });
        closeLoading();
        return response;
    }
    async changePassword(hash, password1, password2) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        if (password1 == '' || password2 == '') {
            Toast.fire({
                icon: 'error',
                title: 'Alguna de las contraseñas esta vacia'
            });
            return;
        }
        if (password1 != password2) {
            Toast.fire({
                icon: 'error',
                title: 'Las contraseñas no coinciden'
            });
            return;
        }
        let payload = new FormData();
        payload.append("hash", hash);
        payload.append("password1", password1);
        payload.append("password2", password2);
        let response = fetch(`${this.API_URL}/api/change-password/`, {
            method: 'POST',
            body: payload,
            credentials: "include"
        });
        closeLoading();
        return response;
    }
    async searchProducts(q, limit = 10, page = 1, order = '') {
        if (!this.is_valid) {
            return;
        }
        //openLoading();
        let user = null;
        let headers = {};
        if (window.Clkec) {
            user = window.Clkec.user;
            if (user) {
                let token = user.getToken();
                if (token) {
                    headers = { "X-CLKECUSER": `${token.access_token}` };
                }
            }
        }
        let params = Object({});
        params['q'] = q;
        params['limit'] = limit;
        params['page'] = page;
        params['o'] = order;
        params['w'] = GetWar();
        params['l'] = GetLang();
        var url = new URL(`${this.API_URL}/api/products/`);
        for (let k in params) {
            url.searchParams.append(k, params[k]);
        }
        let response = await fetch(url.toString(), { method: 'GET', headers: headers, credentials: "include" });
        let json = await response.json();
        //closeLoading();
        fbqSearch(q, json);
        gtagSearch(q, json);
        return json;
    }
    async fetchUserData(token) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let response = await fetch(`${this.API_URL}/api/user/`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        let json = await response.json();
        closeLoading();
        return json;
    }
    async renewLoginToken(username, token) {
        if (!this.is_valid) {
            return;
        }
        let payload = new FormData();
        payload.append("username", username);
        let response = await fetch(`${this.API_URL}/api/token/renew/`, {
            method: "POST",
            body: payload,
            credentials: "include",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        let json = await response.json();
        if (!response.ok) {
            throw json;
        }
        return json;
    }
    async getUserOrders(token) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let response = await fetch(`${this.API_URL}/api/user/orders/`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        let json = await response.json();
        closeLoading();
        return json;
    }
    async getUpdateProfileForm(token) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let response = await fetch(`${this.API_URL}/api/profile/`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new LoginError("Something bad happened");
        }
        let json = await response.json();
        closeLoading();
        return json;
    }
    async updateUserProfile(token, payload) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let response = await fetch(`${this.API_URL}/api/profile/`, {
            method: "PUT",
            credentials: "include",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-type": "application/json"
            },
            body: JSON.stringify(payload)
        });
        let json = await response.json();
        closeLoading();
        return json;
    }
    // CART methods
    async validateCart(payload) {
        if (!this.is_valid) {
            return;
        }
        let json = null;
        // Esto venia de master via
        // let params = Object({});
        // params['w'] = GetWar();
        // params['l'] = GetLang();
        // var url = new URL(`${this.API_URL}/api/cart/`);
        // for (let k in params) { url.searchParams.append(k, params[k]); }
        // let response;
        openLoading();
        let body_payload = JSON.stringify(payload);
        if (body_payload) {
            if (body_payload.indexOf('ERRORCARRITO') > 0) {
                console.log('ERRORCARRITO');
                body_payload = null;
            }
        }
        if (!body_payload) {
            closeLoading();
            return null;
        }
        try {
            json = await clkecFetch(`${this.API_URL}/api/cart/`, {
                method: 'POST',
                body: body_payload,
                credentials: "include",
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                },
            }).catch(e => {
                closeLoading();
                return null;
            });
        }
        catch (e) {
            closeLoading();
            return null;
        }
        closeLoading();
        return json;
    }
    async listShippingAddress() {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let user = null;
        let headers = Object({});
        if (window.Clkec) {
            user = window.Clkec.user;
            if (user) {
                let token = user.getToken();
                if (token) {
                    headers = { "X-CLKECUSER": `${token.access_token}` };
                }
            }
        }
        if (Object.keys(headers).length == 0) {
            console.debug('shipping', 'No user logged in');
            return;
        }
        headers['Content-type'] = 'application/json';
        console.log('headers', headers);
        var url = new URL(`${this.API_URL}/api/shipping/list/`);
        let response = await fetch(url.toString(), {
            method: 'GET',
            headers: headers,
            credentials: "include"
        });
        let json = await response.json();
        closeLoading();
        return json;
    }
    async detailShippingAddress(id) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let user = null;
        let headers = Object({});
        if (window.Clkec) {
            user = window.Clkec.user;
            if (user) {
                let token = user.getToken();
                if (token) {
                    headers = { "X-CLKECUSER": `${token.access_token}` };
                }
            }
        }
        if (Object.keys(headers).length == 0) {
            console.debug('shipping', 'No user logged in');
            return;
        }
        headers['Content-type'] = 'application/json';
        var url = new URL(`${this.API_URL}/api/shipping/${id}/detail/`);
        let response = await fetch(url.toString(), {
            method: 'GET',
            credentials: "include"
        });
        let json = await response.json();
        closeLoading();
        return json;
    }
    async createShippingAddress(data) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let user = null;
        let headers = Object({});
        if (window.Clkec) {
            user = window.Clkec.user;
            if (user) {
                let token = user.getToken();
                if (token) {
                    headers = { "X-CLKECUSER": `${token.access_token}` };
                }
            }
        }
        if (Object.keys(headers).length == 0) {
            console.debug('shipping', 'No user logged in');
            return;
        }
        headers['Content-type'] = 'application/json';
        var url = new URL(`${this.API_URL}/api/shipping/add/`);
        let response = await fetch(url.toString(), {
            method: 'POST',
            body: JSON.stringify(data),
            headers: headers,
            credentials: "include"
        });
        let json = await response.json();
        closeLoading();
        return json;
    }
    async updateShippingAddress(data) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let user = null;
        let headers = Object({});
        let obj = Object(data);
        if (window.Clkec) {
            user = window.Clkec.user;
            if (user) {
                let token = user.getToken();
                if (token) {
                    headers = { "X-CLKECUSER": `${token.access_token}` };
                }
            }
        }
        if (Object.keys(headers).length == 0) {
            console.debug('shipping', 'No user logged in');
            return;
        }
        headers['Content-type'] = 'application/json';
        let sid = obj['id'];
        var url = new URL(`${this.API_URL}/api/shipping/${sid}/update/`);
        let response = await fetch(url.toString(), {
            method: 'PUT',
            body: JSON.stringify(obj),
            headers: headers,
            credentials: "include"
        });
        let json = await response.text();
        closeLoading();
        return json;
    }
    async deleteShippingAddress(id) {
        if (!this.is_valid) {
            return;
        }
        openLoading();
        let user = null;
        let headers = Object({});
        if (window.Clkec) {
            user = window.Clkec.user;
            if (user) {
                let token = user.getToken();
                if (token) {
                    headers = { "X-CLKECUSER": `${token.access_token}` };
                }
            }
        }
        if (Object.keys(headers).length == 0) {
            console.debug('shipping', 'No user logged in');
            return;
        }
        headers['Content-type'] = 'application/json';
        var url = new URL(`${this.API_URL}/api/shipping/${id}/delete/`);
        let response = await fetch(url.toString(), {
            method: 'DELETE',
            headers: headers,
            credentials: "include"
        });
        let json = await response.text();
        closeLoading();
        return json;
    }
    async templateShippingAddress(data) {
        if (!this.is_valid) {
            return;
        }
        let headers = Object({});
        let payload = Object({
            "street": "",
            "township": 0,
            "zone": 0,
            "house": "",
            "apartment": "",
            "reference": "",
            "id": null
        });
        Object.keys(data).forEach(field => {
            payload[field] = Object(data)[field];
        });
        headers['Content-type'] = 'application/json';
        var url = new URL(`${this.API_URL}/api/shipping/template/`);
        let response = await fetch(url.toString(), {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: headers,
            credentials: "include"
        });
        return await response.text();
    }
    async verifyUnique(value) {
        if (this.lastEvent === window.event) {
            return this.lastEventResult;
        }
        if (this.lastEvent) {
            console.log('lastEvent', this.lastEvent.timeStamp);
        }
        if (window.event) {
            console.log('event', window.event.timeStamp);
        }
        if (this.lastEvent && window.event && this.lastEvent.timeStamp + 100 > window.event.timeStamp) {
            return this.lastEventResult;
        }
        this.lastEventResult = null;
        this.lastEvent = window.event;
        console.debug('verifyUnique');
        let response = await fetch(`${this.API_URL}/api/validate-unique/${value}/`, {
            method: 'GET'
        });
        if (response.status !== 200) {
            throw new LoginError("Something bad happened");
        }
        let json = await response.json();
        json = JSON.parse(json);
        this.lastEventResult = json['valid'];
        return json['valid'];
    }
    async getShippingOptions() {
        console.debug('getShippingOptions');
        let user = null;
        let session_id = '';
        let clkuser = '';
        if (window.Clkec) {
            user = window.Clkec.user;
            if (user) {
                let token = user.getToken();
                if (token) {
                    clkuser = `${token.access_token}`;
                }
                session_id = window.Clkec.user.getSessionId();
            }
        }
        var url = new URL(`${this.API_URL}/api/shipping/options/`);
        let response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'X-CLKECSESSIONID': session_id,
                'X-CLKECUSER': clkuser
            },
            credentials: 'include'
        });
        if (response.status !== 200) {
            throw new LoginError("Something bad happened");
        }
        let json = await response.json();
        return json['values'];
    }
    async getPaymentsOptions() {
        console.debug('getPaymentsOptions');
        let user = null;
        let session_id = '';
        let clkuser = '';
        if (window.Clkec) {
            user = window.Clkec.user;
            if (user) {
                let token = user.getToken();
                if (token) {
                    clkuser = `${token.access_token}`;
                }
                session_id = window.Clkec.user.getSessionId();
            }
        }
        '';
        var total = window.Clkec.cart.total.toFixed(window.CHECKOUT_DECIMAL_PLACES);
        var url = new URL(`${this.API_URL}/api/payments/options/?total=${total}`);
        const flavourMeta = document.querySelector('meta[name=flavour]');
        var flavour = 'full';
        if (flavourMeta) {
            flavour = flavourMeta.content;
        }
        let response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'X-CLKECSESSIONID': session_id,
                'X-CLKECUSER': clkuser,
                'X-FLAVOUR': flavour
            },
            credentials: 'include'
        });
        if (response.status !== 200) {
            throw new LoginError("Something bad happened");
        }
        let json = await response.json();
        return json['values'];
    }
}
class Obj1 {
}
class CustomerShipping {
}
class MultiLevelMenu {
    constructor(nav, menu, method, arrow = null, alternative = null) {
        this.getBack = () => {
            this.currentLevel.pop();
            this.drawMenu(this.currentLevel[this.currentLevel.length - 1], true);
        };
        this.readMenu = (parent) => {
            for (let i = 0; i < parent.children.length; i++) {
                const nodeName = this.method + "-";
                if (parent.children[i].children.length > 0) {
                    parent.children[i].children[0].dataset.name = nodeName + this.index;
                    this.items.push(nodeName + this.index);
                    let content = parent.children[i].classList.contains('content');
                    if (content) {
                        this.obj.push({
                            nofollow: false,
                            gotoall: false,
                            content: content,
                            parent: null,
                            element: parent.children[i].children[0]
                        });
                    }
                    else {
                        this.obj.push({
                            text: parent.children[i].children[0].text,
                            element: parent.children[i].children[0],
                            link: parent.children[i].children[0].href,
                            nofollow: parent.children[i].children[0].classList.contains('nofollow'),
                            gotoall: parent.children[i].children[0].classList.contains('gotoall'),
                            shortcut: parent.children[i].classList.contains('shortcut'),
                            content: content,
                            basico: parent.children[i].classList.contains('basico'),
                            name: parent.children[i].children[0].dataset.name,
                            parent: (parent.children[0].parentNode.parentNode.children[0].dataset.name) ? parent.children[0].parentNode.parentNode.children[0].dataset.name : null,
                            children: (parent.children[i].children[1]) ? true : false
                        });
                    }
                    this.index++;
                    if (parent.children[i].children[1]) {
                        this.readMenu(parent.children[i].children[1]);
                    }
                }
            }
        };
        this.method = method;
        this.arrow = arrow;
        this.alternative = alternative;
        this.items = [];
        this.index = 0;
        this.obj = [];
        this.nav = nav;
        this.menu = menu;
        this.multilevel = document.createElement('div');
        this.multilevel.className = this.method;
        this.nav.insertBefore(this.multilevel, this.menu);
        this.currentLevel = [];
        menu ? this.readMenu(menu) : null;
        menu.style.display = "none";
    }
    get menuItems() {
        return this.items;
    }
    drawMenu(parent = null, back = null) {
        parent = parent || null;
        if (!back)
            this.currentLevel.push(parent);
        if (this.multilevel.children.length >= 2) {
            this.multilevel.children[0].remove();
        }
        const dl = document.createElement('dl');
        if (parent) {
            const dt = document.createElement('dt');
            const a = document.createElement('a');
            const img = document.createElement('img');
            img.setAttribute('alt', 'arrow');
            const span = document.createElement('span');
            (this.arrow) ? img.setAttribute("src", this.arrow) : null;
            a.href = "#";
            a.setAttribute('onclick', `Clkec.menu.mainMenu1.getBack()`);
            const aux = document.querySelector(`[data-name="${parent}"]`);
            span.textContent = (!this.alternative) ? aux.text : this.alternative;
            dt.appendChild(a);
            (this.arrow) ? a.appendChild(img) : null;
            a.appendChild(span);
            dl.appendChild(dt);
        }
        for (let i = 0; i < this.obj.length; i++) {
            if (this.obj[i].parent === parent) {
                const dd = document.createElement('dd');
                if (this.obj[i].content) {
                    dd.classList.add('content');
                    dd.appendChild(this.obj[i].element);
                }
                else {
                    const a = document.createElement('a');
                    const spanName = document.createElement('span');
                    const pName = document.createElement('p');
                    (this.arrow) ? a.appendChild(spanName) : a.appendChild(pName);
                    if (this.obj[i].children) {
                        const img = document.createElement('img');
                        img.setAttribute('onclick', `Clkec.menu.mainMenu1.drawMenu("${this.obj[i].name}")`);
                        img.setAttribute('alt', 'arrow');
                        (this.arrow) ? img.setAttribute("src", this.arrow) : null;
                        (this.arrow) ? a.appendChild(img) : null;
                    }
                    (this.arrow) ? spanName.textContent = this.obj[i].text : pName.appendChild(this.obj[i].element);
                    a.href = this.obj[i].link;
                    if (this.obj[i].nofollow) {
                        a.href = '#';
                        a.setAttribute('onclick', `Clkec.menu.mainMenu1.drawMenu("${this.obj[i].name}")`);
                    }
                    if (this.obj[i].gotoall) {
                        dd.classList.add('gotoall');
                    }
                    if (this.obj[i].shortcut) {
                        dd.classList.add('shortcut');
                    }
                    if (this.obj[i].basico) {
                        dd.classList.add('basico');
                    }
                    a.style.display = "flex";
                    a.addEventListener('click', (event) => {
                        let cel = event.target;
                        if (cel.nodeName === 'IMG') {
                            event.preventDefault();
                            event.stopPropagation();
                            return false;
                        }
                        return;
                        true;
                    });
                    dd.appendChild(a);
                }
                dl.appendChild(dd);
            }
        }
        this.multilevel.appendChild(dl);
        if (this.multilevel.children.length > 1) {
            if (back) {
                this.multilevel.children[0].className = "menu-left-out";
                this.multilevel.children[1].className = "menu-right-in";
            }
            else {
                this.multilevel.children[0].className = "menu-right-out";
                this.multilevel.children[1].className = "menu-left-in";
            }
        }
    }
}
;
